<template>
  <j-modal
    :okButtonProps="{ class: { 'jee-hidden': disableSubmit } }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    @ok="handleOk"
    cancelText="关闭"
    switchFullscreen
  >
    <yw-artificial-patrol-task-detail-form
      :disabled="disableSubmit"
      @ok="submitCallback"
      ref="realForm"
    ></yw-artificial-patrol-task-detail-form>
    <template slot="footer">
      <a-button @click="handleOk('1')" type="primary" v-if="!disableSubmit">保存</a-button>
      <a-button @click="handleOk('3')" type="primary" v-if="!disableSubmit">完结</a-button>
      <a-button @click="handleCancel">关闭</a-button>
    </template>
  </j-modal>
</template>

<script>
import YwArtificialPatrolTaskDetailForm from './YwArtificialPatrolTaskDetailForm'
export default {
  name: 'YwArtificialPatrolTaskDetailModal',
  components: {
    YwArtificialPatrolTaskDetailForm
  },
  data() {
    return {
      title: '巡检任务执行',
      width: 1400,
      visible: false,
      disableSubmit: false
    }
  },
  methods: {
    //   add () {
    //     this.visible=true
    //     this.$nextTick(()=>{
    //       this.$refs.realForm.add();
    //     })
    //   },
    //   edit (record) {
    //     this.visible=true
    //     this.$nextTick(()=>{
    //       this.$refs.realForm.edit(record);
    //     })
    //   },
    show(record) {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.realForm.show(record)
      })
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk(taskStatus) {
      this.$refs.realForm.submitForm(taskStatus)
    },
    submitCallback() {
      this.$emit('ok')
      this.visible = false
    },
    handleCancel() {
      this.close()
    }
  }
}
</script>
